import type { JobStatus } from '@conversia/shared-types';

/**
 * Línea de tiempo tipo Uber del trabajo — lógica PURA (la UI la pinta).
 * Mapea los estados del trabajo a 3 pasos visuales; no inventa estados nuevos.
 */

export type TimelineStepState = 'done' | 'current' | 'pending' | 'failed';

export interface TimelineStep {
  label: string;
  state: TimelineStepState;
}

const LABELS = ['Técnico en camino', 'Técnico ha llegado', 'Trabajo realizado'] as const;

export function timelineFromEstado(estado: JobStatus): TimelineStep[] {
  switch (estado) {
    case 'ASIGNADO':
      return [
        { label: LABELS[0], state: 'current' },
        { label: LABELS[1], state: 'pending' },
        { label: LABELS[2], state: 'pending' },
      ];
    case 'EN_SITIO':
      return [
        { label: LABELS[0], state: 'done' },
        { label: LABELS[1], state: 'current' },
        { label: LABELS[2], state: 'pending' },
      ];
    // S-01: el técnico terminó su parte y el trabajo espera la validación de
    // supervisión. El proceso está EN el último paso, no terminado: pintarlo
    // como COMPLETADO haría creer que no queda nada por hacer.
    case 'PENDIENTE_VALIDACION':
      return [
        { label: LABELS[0], state: 'done' },
        { label: LABELS[1], state: 'done' },
        { label: LABELS[2], state: 'current' },
      ];
    case 'COMPLETADO':
      return [
        { label: LABELS[0], state: 'done' },
        { label: LABELS[1], state: 'done' },
        { label: LABELS[2], state: 'done' },
      ];
    case 'NO_COMPLETADO':
      return [
        { label: LABELS[0], state: 'done' },
        { label: LABELS[1], state: 'done' },
        { label: 'No completado', state: 'failed' },
      ];
    case 'CANCELADO':
      // Cancelado por el panel: no se inventa avance del técnico — los pasos
      // quedan pendientes y el cierre marca la cancelación.
      return [
        { label: LABELS[0], state: 'pending' },
        { label: LABELS[1], state: 'pending' },
        { label: 'Cancelado', state: 'failed' },
      ];
  }
}
